import { memo } from "react";
import classNames from "classnames";

import { ReactComponent as ArrowUp } from "./icons/arrow-up.svg";

import styles from "./style.module.scss";

type SortComponentProps = { canSort: boolean, isSorted: boolean, isSortedDesc?: boolean, className?: string };

const SortComponent = memo<SortComponentProps>(({ className, canSort, isSorted, isSortedDesc }) => {
  if (!canSort) {
    return null;
  }
  return (
    <span
      data-active={isSorted}
      className={classNames(className, styles.root, {
        [styles.sorted]: isSorted,
        [styles.sortedDesc]: isSortedDesc,
      })}
    >
      <ArrowUp />
    </span>
    //   {
    //     isSorted
    //       ? isSortedDesc
    //       ? " 🔽"
    //       : <ArrowUp />
    //       : "";
    //   }
    // </span>
  );
});

export default SortComponent;
